import { useState } from "react";
 
export default function MessageInput({ onSend }) {
  const [text, setText] = useState("");
 
  const handleSend = () => {
    if (!text.trim()) return;
    onSend(text.trim());
    setText("");
  };
 
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
 
  return (
    <div style={styles.bar}>
      {/* Emoji */}
      <button style={styles.iconBtn} title="Emoji">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <line x1="9" y1="9" x2="9.01" y2="9" />
          <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
      </button>
 
      {/* Attachment */}
      <button style={styles.iconBtn} title="Attach file">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
      </button>
 
      {/* Text field */}
      <textarea
        rows={1}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type a message"
        style={styles.input}
      />
 
      {/* Send or Mic */}
      {text.trim() ? (
        <button onClick={handleSend} style={styles.sendBtn} title="Send">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13" />
            <polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
        </button>
      ) : (
        <button style={styles.iconBtn} title="Voice message">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="23" />
            <line x1="8"  y1="23" x2="16" y2="23" />
          </svg>
        </button>
      )}
    </div>
  );
}
 
const styles = {
  bar: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "10px 14px",
    borderTop: "1px solid #000000ff",
    background: "#000000ff",
    flexShrink: 0,        // ← CRITICAL: never let this shrink or get pushed off screen
  },
  iconBtn: {
    background: "none",
    border: "none",
    borderRadius: 8,
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    padding: 0,
  },
  input: {
    flex: 1,
    border: "1px solid #2b2b2bff",
    borderRadius: 10,
    padding: "9px 14px",
    fontSize: 14,
    color: "#fbfbfcff",
    outline: "none",
    resize: "none",
    lineHeight: 1.5,
    fontFamily: "inherit",
    background: "#2b2b2bff",
    maxHeight: 100,
    overflowY: "auto",
    minHeight: 38,
  },
  sendBtn: {
    background: "#1a3c5e",
    border: "none",
    borderRadius: "50%",
    width: 38,
    height: 38,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
  },
};